import { admin2 } from '@/api/instance'

/**
 * 取得預約回覆待確認列表
 *
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 店家 ID
 * @param {number} params.start - 起始索引 (pagination offset)
 * @param {number} params.limit - 每頁筆數 (pagination limit)
 * @param {string} [params.replyStatus] - 回覆狀態篩選 ('pending' | 'expired')
 * @returns {Promise<Array>} 預約訂單列表
 * @example
 * const result = await GetAppointmentReplyPending({
 *   shopId: 'shop123',
 *   start: 0,
 *   limit: 20,
 *   replyStatus: 'expired'
 * })
 */
export const GetAppointmentReplyPending = async ({ shopId, start, limit, replyStatus }) => {
  const params = {
    start,
    limit,
  }
  if (replyStatus) {
    params.replyStatus = replyStatus
  }

  return await admin2({
    method: 'GET',
    url: `/${shopId}/appointmentOrderReplyPending`,
    params,
  })
}

/**
 * 取得預約回覆待確認列表總數
 *
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 店家 ID
 * @param {string} [params.replyStatus] - 回覆狀態篩選 ('pending' | 'expired')
 * @returns {Promise<Object>} 包含 count 欄位的物件
 * @example
 * const result = await GetAppointmentReplyPendingCount({
 *   shopId: 'shop123',
 *   replyStatus: 'expired'
 * })
 * // result.data.count === 42
 */
export const GetAppointmentReplyPendingCount = async ({ shopId, replyStatus }) => {
  const params = {}
  if (replyStatus) {
    params.replyStatus = replyStatus
  }

  return await admin2({
    method: 'GET',
    url: `/${shopId}/appointmentOrderReplyPending/count`,
    params,
  })
}

/**
 * 批次標記預約訂單為已回覆
 *
 * @param {Object} params - 請求參數
 * @param {string} params.shopId - 店家 ID
 * @param {string[]} params.appointmentOrderIds - 預約訂單 ID 陣列
 * @returns {Promise<Object>} 包含 msg 欄位的回應物件
 * @example
 * const result = await BatchMarkAsReplied({
 *   shopId: 'shop123',
 *   appointmentOrderIds: ['order1', 'order2', 'order3']
 * })
 */
export const BatchMarkAsReplied = async ({ shopId, appointmentOrderIds }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrderReplyPending/batchMarkAsReplied`,
    data: {
      appointmentOrderIds,
    },
  })
}

/**
 * 批次取消預約訂單
 *
 * @param {Object} params - 請求參數
 * @param {string} params.shopId - 店家 ID
 * @param {string[]} params.appointmentOrderIds - 預約訂單 ID 陣列
 * @returns {Promise<Object>} 包含 msg 欄位的回應物件
 * @example
 * const result = await BatchCancel({
 *   shopId: 'shop123',
 *   appointmentOrderIds: ['order1', 'order2', 'order3']
 * })
 */
export const BatchCancel = async ({ shopId, appointmentOrderIds }) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrderReplyPending/batchCancel`,
    data: {
      appointmentOrderIds,
    },
  })
}
